import Endpoint from "../endpoint";

export class ServiceBase {
  endpoint: Endpoint = new Endpoint("");

    constructor(endpoint: Endpoint) {
        this.endpoint = endpoint;
    }
}